import emailjs from "@emailjs/browser";
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

// Assets
import ContactImg1 from "../../assets/img/contact1.avif";
import ContactImg2 from "../../assets/img/contact2.avif";
import ContactImg3 from "../../assets/img/contact3.jpg";

export default function Contact() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.0, });
  const [formData, setFormData] = useState({
    fname: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error when user types
  };

  // Validate form fields
  const validateForm = () => {
    let newErrors = {};
    if (!formData.fname.trim()) newErrors.fname = "First name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    emailjs
      .send(
        "service_c5j2u6e", 
        "template_oi6myac",
        formData,
        "Q3LDTZaOhF32HtucU" 
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          console.log("SUCCESS!", response.status, response.text);
          setFormData({ fname: "", email: "", subject: "", message: "" });
        },
        (err) => {
          alert("Failed to send message. Try again later.");
          console.log("FAILED...", err);
        }
      );
  };

  return (
    <Wrapper id="contact" ref={ref}
      className={`container ${inView ? "animate__animated animate__slideInLeft" : "opacity-0"}`}>
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold animated-gradient-text">Let's get in touch</h1>
            <p className="font13">
              Have a project in mind? Need expert solutions for website development, app development, or cloud services? We’re here to help!
              <br />

              Reach out to us today, and let’s create something amazing together! 🚀

            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <Form onSubmit={handleSubmit}>
            <label className="font13">First name:</label>
            <input type="text" name="fname" value={formData.fname} onChange={handleChange} className="font15 whiteColor" />
            {errors.fname && <ErrorText>{errors.fname}</ErrorText>}

            <label className="font13">Email:</label>
            <input type="text" name="email" value={formData.email} onChange={handleChange} className="font15 whiteColor" />
            {errors.email && <ErrorText>{errors.email}</ErrorText>}

            <label className="font13">Subject:</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="font15 whiteColor" />
            {errors.subject && <ErrorText>{errors.subject}</ErrorText>}

            <label className="font13">Message:</label>
            <textarea rows="4" name="message" value={formData.message} onChange={handleChange} className="font15 whiteColor" />
            {errors.message && <ErrorText>{errors.message}</ErrorText>}

            <SumbitWrapper className="flex">
              <button
                type="submit"
                className="pointer animate radius8"
                style={{
                  border: "1px solid #7620ff",
                  backgroundColor: "#7620ff",
                  width: "100%",
                  padding: "15px",
                  outline: "none",
                  color: "#fff",
                  maxWidth: "220px",
                  transition: "background-color 0.3s ease, color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#580cd2";
                  e.target.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#7620ff";
                  e.target.style.color = "#fff";
                }}
              >
                Send Message
              </button>
            </SumbitWrapper>
          </Form>
            </div>

            <DesktopOnly className="flex col-xs-12 col-sm-6 col-md-6 col-lg-6"
            >

              <div style={{ width: "50%" }} className="flexNullCenter flexColumn">
                <ContactImgBox>
                  <img src={ContactImg1} alt="office" className="radius6" style={{ width: "100%" }} />
                </ContactImgBox>
                <ContactImgBox>
                  <img src={ContactImg2} alt="office" className="radius6" style={{ width: "100%" }} />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img src={ContactImg3} alt="office" className="radius6" style={{ width: "100%" }} />
                </div>
              </div>
            </DesktopOnly>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const ErrorText = styled.p`
  color: red;
  font-size: 12px;
  margin-top:-25px;
  margin-bottom: 10px;
`;

const DesktopOnly = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 768px) {
    display: flex;
  }
`;

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
 
`;
const ContactImgBox = styled.div`
  max-width: 180px; 
  align-self: flex-end; 
  margin: 10px 30px 10px 0;
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;









